<template>
    <div class="zwinfobbox">

        <div class="companyinfobox" v-if="companyInfo">
            <el-image class="avater1" fit="contain" :src="companyInfo.customCompanyLogo"></el-image>
            <div class="cccn">{{ companyInfo.customCompanyName }}</div>
            <div class="cccbox">
                <div>在招职位({{ companyInfo.jobCount }})</div>
                <div>offer({{ companyInfo.offerNumber }})</div>
            </div>
            <div class="cccbox">
                <div>行业：{{ companyInfo.industry }}</div>
            </div>
            <div class="cccbox">
                <div>城市：{{ companyInfo.inTheCity }}</div>
            </div>
            <div class="cccbox">
                <div>地址：{{ companyInfo.detailedAddress }}</div>
            </div>
        </div>

        <div class="zwinfobox" v-if="setitem">
            <div class="topbtnbox">
                <div class="actionbtn4" @click="getlinktype()"><i class="el-icon-phone-outline"></i>联系发布者</div>
                <div v-if="setitem.isFollowJob === '0'" class="actionbtn1" @click="followjob()"><i
                        class="el-icon-star-off"></i>关注</div>
                <div v-if="setitem.isFollowJob === '1'" class="actionbtn2" @click="followjob()"><i
                        class="el-icon-star-on"></i>已关注
                </div>
                <div class="actionbtn3" @click="showUploadRes()"><i class="el-icon-tickets"></i>投递简历</div>
            </div>
            <div class="qyname">{{ Number(setitem.isCompany) === 1 ? setitem.companyNameCustom ? setitem.companyNameCustom :
                '某公司' : setitem.customCompanyEVo.customCompanyFullName }}</div>
            <div class="zwname">{{ setitem.positionName }} <el-tag v-show="setitem.label !== ''"
                    v-for="(item, index) in (setitem.label.split(':'))" :key="index" :type="tagstyle[index]">{{ item
                    }}</el-tag>
            </div>
            <div class="jcinfo">
                <span><i class="el-icon-money"></i>{{ setitem.minYearSalary + '~' + setitem.maxYearSalary + 'w'
                }}</span>
                <span><i class="el-icon-map-location"></i>{{ setitem.workPlace + ',' + setitem.cityName }}</span>
                <span><i class="el-icon-s-opportunity"></i>{{ setitem.minEducation }}</span>
                <span><i class="el-icon-alarm-clock"></i>{{ setitem.workingLifeMin + '~' + setitem.workingLifeMax +
                    '年' }}</span>
                <span><i class="el-icon-user"></i>{{ setitem.recruitsNumber + '人' }}</span>
                <span><i class="el-icon-suitcase"></i>{{ setitem.industry }}</span>

            </div>
            <div class="jcinfo1">
                <div><span>佣金:</span><span style="color: #db1a1a">{{ Number(
                    ((((Number(setitem.salaryMax) +
                        Number(setitem.salaryMin)) *
                        9) /
                        100) *
                        Number(70)) /
                    100
                ).toFixed(2) + 'w' }}</span></div>
                <div><span>分成:</span>{{ setitem.commissionRate }}%</div>
                <div><span>保证期:</span>{{ setitem.warranty }}</div>
                <div><span>付款细则:</span>{{ setitem.payRules }}</div>
                <div><span>更新日期:</span>{{ moment(setitem.updateTime).format('YYYY-MM-DD') }}</div>
            </div>
            <div class="jcinfo1">
                <div><span>投递:</span>{{ setitem.statusList[1].statusNum }}</div>
                <div><span>推荐:</span>{{ setitem.statusList[2].statusNum }}</div>
                <div><span>面试:</span>{{ setitem.statusList[3].statusNum }}</div>
                <div><span>Offer:</span>{{ setitem.statusList[4].statusNum }}</div>
            </div>

            <el-tabs v-model="activeName" style="margin-top: 30px;width: 100%;">
                <el-tab-pane label="职位详情" name="first">
                    <div class="bt">岗位职责</div>
                    <div class="infot">{{ setitem.postDuties }}</div>
                    <div class="bt">任职要求</div>
                    <div class="infot">{{ setitem.postReQuirements }}</div>
                    <div class="bt" v-if="setitem.des !== ''">特殊备注</div>
                    <div class="infot" v-if="setitem.des !== ''">{{ setitem.des }}</div>
                    <div class="bt">补充信息</div>
                    <el-descriptions class="margin-top" title="" :column="3" :size="size" border>
                        <el-descriptions-item>
                            <template slot="label">
                                工作地址
                            </template>
                            {{ setitem.workingAddress }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                所属部门
                            </template>
                            {{ setitem.branch }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                人选必备项
                            </template>
                            {{ setitem.personSelEssential }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                人选核心项
                            </template>
                            {{ setitem.personSelCore }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                人选加分项
                            </template>
                            {{ setitem.personSelBonuspoint }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                面试流程
                            </template>
                            {{ setitem.interviewProcess }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                工作时间
                            </template>
                            {{ setitem.workHours }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                汇报对象
                            </template>
                            {{ setitem.reportObject }}
                        </el-descriptions-item>
                    </el-descriptions>

                </el-tab-pane>
                <el-tab-pane label="公告反馈" name="second">
                    <div class="bt">职位公告</div>
                    <el-empty v-if="zwgg.length <= 0" description="当前暂无职位公告"></el-empty>
                    <div class="fkBox">
                        <div class="tipbox" v-for="(item, index) in zwgg" :key="index">
                            <div class="boxtop">
                                <div class="topp1">
                                    {{ item.fullName }}
                                </div>
                                <div class="topp2">
                                    {{ item.xsTime }}
                                </div>

                            </div>
                            <div class="boxbottom">
                                {{ item.notice }}
                            </div>
                        </div>
                    </div>


                </el-tab-pane>
                <el-tab-pane v-if="Number(setitem.isCompany) !== 1" label="客户详情" name="third">
                    <div v-if="Number(setitem.isCompany) === 0">
                        <div class="bt">公司详情</div>
                        <el-descriptions class="margin-top" title="" :column="3" :size="size" border>
                            <el-descriptions-item>
                                <template slot="label">
                                    企业名称
                                </template>
                                {{ setitem.customCompanyEVo.customCompanyFullName }}
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    公司行业
                                </template>
                                {{ setitem.customCompanyEVo.industry }}
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    公司地址
                                </template>
                                {{ setitem.customCompanyEVo.detailedAddress }}
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    企业网站
                                </template>
                                <a :href="setitem.customCompanyEVo.customCompanyWeb" target="_blank">{{
                                    setitem.customCompanyEVo.customCompanyWeb }}</a>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    融资情况
                                </template>
                                {{ setitem.customCompanyEVo.financingStage }}
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    人员规模
                                </template>
                                {{ setitem.customCompanyEVo.staffSize }}
                            </el-descriptions-item>
                        </el-descriptions>

                        <div v-if="setitem.customCompanyEVo.describes !== '' && setitem.customCompanyEVo.describes !== null"
                            class="bt">
                            公司简介
                        </div>
                        <div v-if="setitem.customCompanyEVo.describes !== '' && setitem.customCompanyEVo.describes !== null"
                            class="btcont" v-html="setitem.customCompanyEVo.describes">

                        </div>
                        <div v-if="setitem.customCompanyEVo.analysis !== '' && setitem.customCompanyEVo.analysis !== null"
                            class="bt">
                            公司分析
                        </div>
                        <div v-if="setitem.customCompanyEVo.analysis !== '' && setitem.customCompanyEVo.analysis !== null"
                            class="btcont" v-html="setitem.customCompanyEVo.analysis">

                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>











            <el-dialog title="发布者信息" :modal-append-to-body="false" :visible.sync="dialogVisible" width="30%">
                <div>联系人：{{ setitem.fullName ? setitem.fullName : "暂无" }}</div>
                <div>联系电话：{{ setitem.jobPhone ? setitem.jobPhone : "暂无" }}</div>
                <div>微信号：{{ setitem.jobWeixinAc ? setitem.jobWeixinAc : "暂无" }}</div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                </span>
            </el-dialog>


            <el-drawer title="简历中心" :modal="false" :modal-append-to-body="false" :visible.sync="drawer" :direction="'rtl'"
                size="100%">
                <div class="jlzxbox">
                    <div class="bt11">所有候选人<el-button type="primary" @click="goupload">前往上传简历</el-button></div>

                    <el-table :data="jlLIst" style="width: 100%" height="60vh">
                        <el-table-column fixed prop="name" label="姓名" width="150">
                        </el-table-column>
                        <el-table-column prop="sex" label="性别" width="120">
                        </el-table-column>
                        <el-table-column prop="age" label="年龄" width="120">
                        </el-table-column>
                        <el-table-column prop="education" label="学历" width="120">
                        </el-table-column>
                        <el-table-column prop="workingLifeMax" label="工作经验" width="300">
                        </el-table-column>
                        <el-table-column prop="nowJob" label="最近职位" width="120">
                        </el-table-column>
                        <el-table-column prop="nowCompany" label="最近公司" width="120">
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="120">
                            <template slot-scope="scope">
                                <el-button @click="postRes(scope.row)" v-if="!scope.row.jobId" type="primary">投递</el-button>
                                <el-button v-if="scope.row.jobId" type="info">已投递</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-empty v-if="jlLIst.length <= 0" description="暂无简历"></el-empty>
                    <el-pagination style="margin: 30px auto 0 auto; text-align: center;" @current-change="getResList"
                        :current-page.sync="pageNumber" :page-size.sync="pageSize" layout="total, prev, pager, next, jumper"
                        :total="pagetotal">
                    </el-pagination>
                </div>

            </el-drawer>

        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
import moment from 'moment'

export default {
    name: 'job',
    props: {},
    data() {
        return {
            activeName: "first",
            Number: Number,
            moment: moment,
            id: false,
            tagstyle: [
                'success',
                'info',
                'warning',
                'danger'
            ],
            setitem: false,
            companyInfo: false,
            zwgg: [],
            jlList: [],
            dialogVisible: false,
            drawer: false,
            jlLIst: [],
            pageSize: 15,
            pageNumber: 1,
            pagetotal: 0,
            xgposlist: []
        }
    },
    watch: {},
    created: function () { },
    methods: {
        beforeRouteLeave(to, form, next) {
            to.meta.keepAlive = true;
            next(0)
        },
        getJlList: function () {
            let that = this
            that.loading = true
            let data = {}
            axios({
                method: 'POST',
                url: Config.path + '/api/candidate/getlotterDrawList',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json',
                },
                data: data,
            })
                .then((res) => {
                    that.loading = false
                    if (res.data.success === '1') {
                        that.jlList = res.data.content
                        that.getJobInfo()
                    } else {
                        that.$message.error(res.data.message)
                    }
                })
                .catch((err) => {
                    that.loading = false
                    that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                })
        },
        getJobInfo: function () {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/candidate/getjobDetail',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    jobId: that.id,
                },
            }).then((res) => {


                const { content, success } = res.data
                const jobInfo = content
                if (!jobInfo.customCompanyEVo) {
                    jobInfo.customCompanyEVo = {
                        "companyId": "string",
                        "customCompanyFullName": "string",
                        "customCompanyLogo": "string",
                        "customCompanyName": "string",
                        "customCompanyNature": "string",
                        "customCompanyWeb": "string",
                        "detailedAddress": "string",
                        "financingStage": "string",
                        "id": "string",
                        "inTheCity": "string",
                        "industry": "string",
                        "staffSize": "string"
                    }
                }

                if (success === '1' && jobInfo) {
                    let a = moment()
                    let b = moment(jobInfo.createTime)
                    if (a.diff(b, 'days') >= 1) {
                        if (
                            moment(jobInfo.createTime).format('YYYY') ===
                            moment().format('YYYY')
                        ) {
                            jobInfo.xsTime =
                                moment(jobInfo.createTime).format('MM月DD日') + ' '
                        } else {
                            jobInfo.xsTime =
                                moment(jobInfo.createTime).format('YYYY年MM月DD日') + ' '
                        }
                    } else if (a.diff(b, 'hours') >= 1) {
                        jobInfo.xsTime = a.diff(b, 'hours') + '小时前 '
                    } else if (a.diff(b, 'minutes') >= 1) {
                        jobInfo.xsTime = a.diff(b, 'minutes') + '分钟前 '
                    } else {
                        jobInfo.xsTime = '刚刚 '
                    }
                    // let lisths = []
                    // let jlitemm = null
                    // let zjNx =
                    //     ((Number(jobInfo.salaryMax) + Number(jobInfo.salaryMin)) * 12) /
                    //     10 /
                    //     2
                    // for (let m in jlList) {
                    //     if (
                    //         zjNx <= Number(jlList[m].maxYearSalary) &&
                    //         zjNx > Number(jlList[m].minYearSalary)
                    //     ) {
                    //         jlitemm = jlList[m]
                    //         if (Number(m) === 0) {
                    //             lisths.push(jlList[m])
                    //             lisths.push(jlList[Number(m) + 1])
                    //         } else if (Number(m) === jlList.length) {
                    //             lisths.push(jlList[Number(m) - 1])
                    //             lisths.push(jlList[m])
                    //         } else {
                    //             lisths.push(jlList[Number(m) - 1])
                    //             lisths.push(jlList[m])
                    //             lisths.push(jlList[Number(m) + 1])
                    //         }
                    //     }
                    // }
                    if (jobInfo.label === null) {
                        jobInfo.label = ""
                    }
                    that.setitem = jobInfo
                    that.getZwGg()
                    if (Number(that.setitem.isCompany) !== 1) {
                        that.getcompanyinfo()
                    }
                    // this.setState(
                    //     {
                    //         jobInfo,
                    //         xzJlItem: jlitemm,
                    //         xzJlList: lisths,
                    //         id: jobInfo.id,
                    //         isFollowing: jobInfo.isFollowJob === '1',
                    //     }
                    // )
                }

            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        getcompanyinfo: function () {
            let that = this
            that.loading = true
            axios({
                method: 'POST',
                url: Config.path + '/api/candidate/getCustomCompanyDetail',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json',
                },
                data: {
                    id: that.setitem.customCompanyEVo.id
                },
            })
                .then((res) => {
                    that.loading = false
                    if (res.data.success === '1') {
                        that.companyInfo = res.data.content
                    } else {
                        that.$message.error(res.data.message)
                    }
                })
                .catch((err) => {
                    that.loading = false
                    that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                })
        },
        closetsc: function () {
            this.setitem = false
        },
        getZwGg: function () {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/candidate/getjobNoticeList',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    jobId: that.id,
                    pageNum: 1,
                    pageSize: 100
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    let demoList = []
                    demoList = res.data.content.list
                    for (let item in demoList) {
                        var a = moment()
                        var b = moment(demoList[item].createTime)
                        if (a.diff(b, 'days') >= 1) {
                            if (
                                moment(demoList[item].createTime).format('YYYY') ===
                                moment().format('YYYY')
                            ) {
                                demoList[item].xsTime =
                                    moment(demoList[item].createTime).format('MM月DD日 HH:mm') +
                                    ' '
                            } else {
                                demoList[item].xsTime =
                                    moment(demoList[item].createTime).format(
                                        'YYYY年MM月DD日 HH:mm'
                                    ) + ' '
                            }
                        } else if (a.diff(b, 'hours') >= 1) {
                            demoList[item].xsTime = a.diff(b, 'hours') + '小时前 '
                        } else if (a.diff(b, 'minutes') >= 1) {
                            demoList[item].xsTime = a.diff(b, 'minutes') + '分钟前 '
                        } else {
                            demoList[item].xsTime = '刚刚 '
                        }
                    }
                    that.zwgg = demoList
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        followjob: function () {
            if (!localStorage.getItem('token')) {
                window.location.href = 'https://www.pinkuaikuai.cn/login.html'
            } else {
                let that = this
                that.loading = true
                let data = {
                    code: that.setitem.id,
                    name: that.setitem.positionName,
                    type: "3"
                }
                axios({
                    method: 'POST',
                    url: Config.path + '/api/candidate/userFollowEdit',
                    headers: {
                        token: localStorage.getItem('token'),
                        'content-type': 'application/json',
                    },
                    data: data,
                })
                    .then((res) => {
                        that.loading = false
                        if (res.data.success === '1') {
                            that.getJobInfo()
                        } else {
                            that.$message.error(res.data.message)
                        }
                    })
                    .catch((err) => {
                        that.loading = false
                        that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                    })
            }
        },
        getlinktype: function () {
            if (!localStorage.getItem('token')) {
                window.location.href = 'https://www.pinkuaikuai.cn/login.html'
            } else {
                this.dialogVisible = true
            }
        },
        showUploadRes: function () {
            if (!localStorage.getItem('token')) {
                window.location.href = 'https://www.pinkuaikuai.cn/login.html'
            } else {
                this.pageNumber = 1
                this.pagetotal = 0
                this.drawer = true
                this.getResList()
            }
        },
        load: function () {
            if (this.jlLIst.length < this.pagetotal) {
                this.pageNumber = this.pageNumber + 1
                this.getResList()
            }
        },
        getResList: function () {
            let that = this
            that.loading = true
            let data = {
                pageSize: that.pageSize,
                pageNum: that.pageNumber,
                jobId: that.id
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/candidate/myResumeList',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json',
                },
                data: data,
            })
                .then((res) => {
                    that.loading = false
                    if (res.data.success === '1') {
                        let demoList = []
                        demoList = res.data.content.list
                        that.pagetotal = res.data.content.total
                        that.jlLIst = demoList
                    } else {
                        that.$message.error(res.data.message)
                    }
                })
                .catch((err) => {
                    

                    that.loading = false
                    that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                })
        },
        deleteRes: function (item) {
            let that = this
            that.loading = true
            this.$confirm('确认删除该简历？')
                .then(_ => {
                    let data = {
                        id: item.id
                    }
                    axios({
                        method: 'POST',
                        url: Config.path + '/api/candidate/delResume',
                        headers: {
                            token: localStorage.getItem('token'),
                            'content-type': 'application/json',
                        },
                        data: data,
                    })
                        .then((res) => {
                            that.loading = false
                            if (res.data.success === '1') {
                                that.pageNumber = 1
                                that.pagetotal = 0
                                that.getResList()
                            } else {
                                that.$message.error(res.data.message)
                            }
                        })
                        .catch((err) => {
                            that.loading = false
                            that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                        })
                })
                .catch(_ => { });
        },
        postRes: function (item) {
            let that = this
            that.loading = true
            this.$confirm('确认投递该简历？')
                .then(_ => {
                    let data = {
                        resumeId: item.id,
                        jobid: that.id
                    }
                    axios({
                        method: 'POST',
                        url: Config.path + '/api/candidate/resumeDeliver',
                        headers: {
                            token: localStorage.getItem('token'),
                            'content-type': 'application/json',
                        },
                        data: data,
                    })
                        .then((res) => {
                            that.loading = false
                            if (res.data.success === '1') {
                                that.pageNumber = 1
                                that.pagetotal = 0
                                that.getResList()
                            } else {
                                that.$message.error(res.data.message)
                            }
                        })
                        .catch((err) => {
                            that.loading = false
                            that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                        })
                })
                .catch(_ => { });
        },
        goupload: function () {
            this.$router.push({
                name: 'upload',
                params: { id: this.id }
            })
        }
    },
    activated : function () {
        this.id = this.$route.params.id
        this.getJlList()
        if (!localStorage.getItem('token')) {
        } else {
            this.pageNumber = 1
            this.pagetotal = 0
            this.getResList()
        }
    },  
    mounted: function () {
        this.id = this.$route.params.id
        this.getJlList()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.zwinfobbox {
    width: 100vw;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
}

.companyinfobox {
    margin-top: 30px;
    width: 300px;
    border-radius: 20px;
    background-color: #ffffff;
    margin-right: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: center;
    padding: 30px;
    box-sizing: border-box;

    .avater1 {
        width: 100px;
        height: 100px;
        border-radius: 100%;
        overflow: hidden;
        margin: 0px auto 0 auto;

    }

    .cccn {
        color: #5dc1cf;
        font-size: 28px;
        font-weight: bold;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .cccbox {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-content: center;
        margin-top: 10px;

        div {
            flex: 1;
            text-align: left;
            color: #cccccc;
        }
    }
}

.zwinfobox {
    border-radius: 20px;
    position: relative;
    top: 0;
    left: 0;
    width: 70%;
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 10px;
    padding: 30px;
    height: calc(100vh - 200px);
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    overflow-y: scroll;
    height: fit-content;
    margin: 30px 0 0 0;

    .qyname {
        font-size: 18px;
        color: #a3a3a3;
        font-weight: bold;
        margin-bottom: 10px;
    }


    .zwname {
        font-size: 40px;
        font-weight: bold;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;

        .el-tag {
            margin-left: 10px;
        }
    }



    .jcinfo {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        margin-top: 10px;
        color: #a3a3a3;

        span {
            i {
                margin-right: 5px;
            }

            margin-right: 20px;
        }
    }


    .jcinfo1 {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        margin-top: 10px;
        color: #606060;

        div {
            span {
                margin-right: 5px;
            }

            margin-right: 20px;
        }
    }

    .infot {
        color: #606060;
        word-wrap: break-word;
        word-break: break-all;
        white-space: pre-wrap;
    }

    .infot1 {
        font-size: 16px;
        color: #606060;
    }

    .infot2 {
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 14px;
        color: #606060;
    }

    .avabox {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        .avaters {
            width: 75px;
            height: 75px;
            border-radius: 100%;
            margin-right: 15px;
        }

    }




    .topbtnbox {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        position: absolute;
        top: 30px;
        right: 30px;


        .actionbtn1 {
            background-color: rgb(27, 192, 109);
            color: #fff;
            margin-top: 20px;
            padding: 0 20px;
            height: 40px;
            line-height: 40px;
            border-radius: 5px;
            text-align: center;
            cursor: pointer;

            i {
                color: #ffffff;
                margin-right: 5px;
            }
        }

        .actionbtn2 {
            background-color: red;
            color: #fff;
            margin-top: 20px;
            padding: 0 20px;
            height: 40px;
            line-height: 40px;
            border-radius: 5px;
            text-align: center;
            cursor: pointer;

            i {
                color: #ffffff;
                margin-right: 5px;
            }
        }

        .actionbtn3 {
            background-color: rgb(14, 214, 171);
            color: #fff;
            margin-top: 20px;
            padding: 0 20px;
            height: 40px;
            line-height: 40px;
            border-radius: 5px;
            text-align: center;
            cursor: pointer;

            i {
                color: #ffffff;
                margin-right: 5px;
            }
        }

        .actionbtn4 {
            background-color: rgb(97, 178, 216);
            color: #fff;
            margin-top: 20px;
            padding: 0 20px;
            height: 40px;
            line-height: 40px;
            border-radius: 5px;
            text-align: center;
            cursor: pointer;

            i {
                color: #ffffff;
                margin-right: 5px;
            }
        }
    }

    .btcont {
        width: 90%;
        margin: 0 auto;
    }

    .bt11 {
        width: 100%;
        font-size: 20px;
        font-weight: bold;
        padding-left: 20px;
        height: 50px;
        line-height: 50px;
        border-left: 5px solid #5dc1cf;
        margin-bottom: 30px;
        margin-top: 30px;
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .btn {
            cursor: pointer;
            width: 120px;
            height: 36px;
            font-size: 18px;
            line-height: 36px;
            border-radius: 36px;
            background-color: #5dc1cf;
            color: #ffffff;
            text-align: center;
        }
    }

    .bt {
        width: 100%;
        font-size: 20px;
        font-weight: bold;
        padding-left: 20px;
        height: 36px;
        line-height: 36px;
        border-left: 5px solid #5dc1cf;
        margin-bottom: 30px;
        margin-top: 30px;
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .btn {
            cursor: pointer;
            width: 120px;
            height: 36px;
            font-size: 18px;
            line-height: 36px;
            border-radius: 36px;
            background-color: #5dc1cf;
            color: #ffffff;
            text-align: center;
        }
    }

    .fkBox {
        width: 90%;
        padding: 30px;
        box-sizing: border-box;
        border-radius: 10px;
        margin: 30px auto;



        .title {
            color: #4d4d4d;
            font-weight: bold;
            margin-bottom: 10px;
        }

        .tip {
            color: #4d4d4d;
        }

        .tipbox {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            margin: 0px 0 30px 0;

            .boxtop {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                width: 100%;

                .topp1 {
                    color: #4d4d4d;
                    font-size: 18px;
                    font-weight: bold;
                    margin-right: 10px;
                    cursor: pointer;
                }

                .topp2 {
                    color: #4d4d4d;
                    font-size: 18px;
                    font-weight: bold;
                    cursor: pointer;
                }

                .close {
                    color: red;
                }

                .pass {
                    color: green;
                }
            }

            .boxbottom {
                margin-bottom: 20px;
                color: #000000;
            }
        }
    }

}
</style>
